import Vue from 'vue'
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import Overview from '../views/Overview.vue';
import Insurances from '../views/Insurances.vue';
import Login from '../views/Login.vue';
import Pension from '../views/Pension';
import Progress from '../views/Progress';
import Measure from '../views/Measure';
import Target from '../views/Target';
import PropertyValuation from '../views/PropertyValuation';
import Achievement from '../views/Achievement';
import NotFound from '../views/NotFound';
import Info from '../views/Info';
import Settings from '../views/Settings.vue';
import Assets from '../views/Assets.vue';
import Registration from '../views/Registration';
import Contact from '../views/Contact';
import Fullmakt from '../views/Fullmakt';
import { adminRoutes } from '../admin/adminRouter';
import store from '../store';

Vue.use(VueRouter)

const routes = [
  ...adminRoutes,
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/overview',
    name: 'overview',
    component: Overview,
    meta: {
      requiresAuth: true
    }
  },
  /*{
    path: '/measure',
    name: 'measure',
    component: Measure,
    meta: {
      requiresAuth: true
    }
  },*/
  {
    path: '/insurances',
    name: 'insurances',
    component: Insurances,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/pension',
    name: 'pension',
    component: Pension,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/progress',
    name: 'progress',
    component: Progress,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/property-valuation',
    name: 'property-valuation',
    component: PropertyValuation,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/target',
    name: 'target',
    component: Target,
    meta: {
      requiresAuth: true
    }
  },
  /*{
    path: '/achievement',
    name: 'achievement',
    component: Achievement,
    meta: {
      requiresAuth: true
    }
  },*/
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta:{
      guest: true
    }
  },
  {
    path: '/register',
    name: 'register',
    component: Registration,
    meta:{
      guest: true
    }
  },
  {
    path: '/register/contact',
    name: 'contact',
    component: Contact,
    meta: {
      requiresAuth: true,
      requiresCompilation:true
    }
  },
  {
    path: '/register/fullmakt',
    name: 'fullmakt',
    component: Fullmakt,
    meta: {
      requiresAuth: true,
      requiresCompilation:true
    }
  },
  {
    path: '/assets',
    name: 'assets',
    component: Assets,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/settings',
    name: 'settings',
    component: Settings,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/info/:page',
    name: 'info',
    component: Info,
    props:true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '*',
    name: 'notFound',
    component: NotFound,
    meta: {
      requiresAuth: true
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
})

router.beforeEach((to, from, next) => {
  let fullmaktPositiveStatus = ['Stored','Signed','Transfered'];
  let userStatus = store.getters.user.status;
  switch (userStatus) {
    case 'loaded':
      if (to.matched.some(record => record.meta.requiresAuth)) {
        if(store.getters.user.contact.status != 'completed' && !to.matched.some(record => record.meta.requiresCompilation )){
          next({ path: '/register/contact'});
        }
        else if(!fullmaktPositiveStatus.includes(store.getters.user.fullmakt.status) && !to.matched.some(record => record.meta.requiresCompilation )){
          next({ path: '/register/fullmakt'});
        }
        else if(fullmaktPositiveStatus.includes(store.getters.user.fullmakt.status) && store.getters.user.contact.status != 'incomplete' && to.matched.some(record => record.meta.requiresCompilation)){
          next({ path: '/', replace:true });
        }
        else{
          next();
        }
      }
      else if (to.matched.some(record => record.meta.guest)) {
        next({ path: '/', replace:true });
      }
      else{
        next();
      }
      break;
    case null:
      store.dispatch('check_loggedIn')
      .then((res)=>{
        if(res){
          next({path:to.fullPath, replace:true});
        }else{
          if (to.matched.some(record => record.meta.requiresAuth)) {
            next({ path: '/login', replace:true });
          }else{
            next();
          }
        }
      })
      .catch((err)=>{
        if (to.matched.some(record => record.meta.guest)) {
          next();
        }else{
          next({ path: '/login', replace:true });
        }
      })
      break
    case 'unauthorized':
      if (to.matched.some(record => record.meta.guest)) {
        next();
      }else{
        next({ path: '/login', replace:true });
      }
      break
    default:
      next();
      break;
  }
  
})

export default router;